import React, {useState, useEffect} from "react";
import { AgGridReact } from "ag-grid-react";
import Modal from 'react-bootstrap/Modal';
import { 
  getInvestedAssetPerf, 
  getInvestedIndexPerf, 
  getMyActivities, 
  getInvestmentMeetings,
  getInvestmentDDQ,
  getInvestedAssetAUM,
  getDocbyActivityId,
  DownloadDocument,
  getInvestmentTasks,
  getActivityDetails,
  getAssetExposures
} from "../../config/apiConfig";
import {sbaAxios} from "../utils/sbaAxios";
import moment from "moment";
import { toast } from "react-toastify";


const defaulColumns = { flex: 1, filter: false };

export const InvestedAssetPerformance = ({assetTypeId}) => {
  const [invAssPerf, setInvAssPerf] = useState([]);

  const fetchInvestedAssetPerf = async () => {
    const repDate = moment().format("MM-DD-YYYY");
    try{
      const list = await sbaAxios({
        url: `${getInvestedAssetPerf}/${repDate}/${assetTypeId || 0}`
      });

      setInvAssPerf(list);
    }
    catch(e){
      setInvAssPerf([]);
    }
  };

  useEffect(() => {
    fetchInvestedAssetPerf();
  },[assetTypeId]);
  const invAssPerfColumns = [
    {
      headerName: "Strategy Name",
      field: "StrategyName",
      rowGroup: true,
      hide: true,
    },
    { headerName: "Asset Name", field: "AssetName", tooltipField: "AssetName", cellStyle:{paddingLeft: "45px"}},
    { 
      headerName: "MTD", 
      field: "MTD",
      valueFormatter: (params) => {
          return new Intl.NumberFormat("en-US", {
              style: "percent",
              minimumFractionDigits: 2
          }).format(params.value);
      }, 
      cellStyle: { textAlign: "right" },
      flex: 0.3
    },
    { 
      headerName: "YTD", 
      field: "YTD",
      valueFormatter: (params) => {
        return new Intl.NumberFormat("en-US", {
            style: "percent",
            minimumFractionDigits: 2
        }).format(params.value);
      }, 
      cellStyle: { textAlign: "right" },
      flex: 0.3
    },
  ];
  return <>
  <div className="ag-theme-alpine" style={{ height: "100%", width: "100%" }}>
  <AgGridReact 
  rowData={invAssPerf}
  columnDefs={invAssPerfColumns}
  defaultColDef={defaulColumns}
  groupDisplayType="groupRows"
  isGroupOpenByDefault={()=>{return true}}
        autoGroupColumnDef={{
          headerName: "Strategy",
          field: "StrategyName",
          cellRendererParams: { suppressCount: true },
        }}
        animateRows={true}
  >
  </AgGridReact>
  </div>
  </>;
};

export const IndexPerformance = () => {
  const [indPerf, setIndPerf] = useState([]);
  const fetchInvestedIndexPerf = async () => {
    const repDate = moment().format("MM-DD-YYYY");
    try{
      const list = await sbaAxios({
        url: `${getInvestedIndexPerf}/${repDate}`
      });
      setIndPerf(list);
    }
    catch(e){
      setIndPerf([]);
    }
  };

  useEffect(() => {
    fetchInvestedIndexPerf();
  },[]);
  const indPerfColumns = [
    { headerName: "Index Performance", field: "MarketIndexName",tooltipField: "MarketIndexName" },
    { 
      headerName: "MTD", 
      field: "MTD",
      valueFormatter: (params) => {
          return new Intl.NumberFormat("en-US", {
              style: "percent",
              minimumFractionDigits: 2
          }).format(params.value);
      }, 
      cellStyle: { textAlign: "right" },
      flex: 0.3
    },
    { 
      headerName: "YTD", 
      field: "YTD",
      valueFormatter: (params) => {
        return new Intl.NumberFormat("en-US", {
            style: "percent",
            minimumFractionDigits: 2
        }).format(params.value);
      }, 
      cellStyle: { textAlign: "right" },
      flex: 0.3
    },
  ];
  return <>
  <div className="ag-theme-alpine" style={{ height: "100%", width: "100%" }}>
  <AgGridReact 
  rowData={indPerf}
  columnDefs={indPerfColumns}
  defaultColDef={defaulColumns}
  >
  </AgGridReact>
  </div>
  </>
};

export const InvestedAssetExposures = ({showAll}) => {
  const [assetExposures, setAssetExposures] = useState([]);

  const fetchAssetExposuress = async(showAllExposure) => {
    try{
      const list = await sbaAxios({
        url:getAssetExposures,
        params: {
          showAll: showAllExposure
        },
        method:'post'
      });
      setAssetExposures(list);
    }
    catch(e){
      setAssetExposures([]);
    }
  };

  useEffect(()=>{
    fetchAssetExposuress(showAll);
  },[showAll]);

  const columns = [
    { headerName: "Asset Name", field: "AssetName", flex:0.5 },
    { 
      headerName: "Date", 
      field: "ExposureDate", 
      valueFormatter: (params) => {
        if (!params.value) return "";
        return moment(params.value).format("MM/DD/YYYY");
      }, 
      flex: 0.3
    },
    { 
      headerName: "Long", 
      field: "Long",
      valueFormatter: (params) => {
        return new Intl.NumberFormat("en-US", {
            style: "percent",
            minimumFractionDigits: 2
        }).format(params.value);
    }, 
    cellStyle: { textAlign: "right" },
    flex: 0.3
    },
    { 
      headerName: "Short", 
      field: "Short",
      valueFormatter: (params) => {
        return new Intl.NumberFormat("en-US", {
            style: "percent",
            minimumFractionDigits: 2
        }).format(params.value);
    }, 
    cellStyle: { textAlign: "right" },
    flex: 0.3
    },
    { 
      headerName: "Gross", 
      field: "Gross",
      valueFormatter: (params) => {
        return new Intl.NumberFormat("en-US", {
            style: "percent",
            minimumFractionDigits: 2
        }).format(params.value);
    }, 
    cellStyle: { textAlign: "right" },
    flex: 0.3
    },
    { 
      headerName: "Net", 
      field: "Net",
      valueFormatter: (params) => {
        return new Intl.NumberFormat("en-US", {
            style: "percent",
            minimumFractionDigits: 2
        }).format(params.value);
    }, 
    cellStyle: { textAlign: "right" },
    flex: 0.3
    }
  ];
  return <>
  <div style={{ width: "100%", height: "100%", overflowX: "auto" }}>
  <div className="ag-theme-alpine" style={{ width: "900px", height: "100%" }}>
    <AgGridReact 
      rowData={assetExposures}
      columnDefs={columns}
      defaultColDef={defaulColumns}
      domLayout="normal" // or 'autoHeight' based on your use case
    />
  </div>
</div>
  </>
};

export const MyRecentActivities = ({bIndex}) => {
  const [activities, setActivities] = useState([]);
    const [documents, setDocuments] = useState([]);
    const [activitydetails, setactivitydetails] = useState([]);
  const [showDocModal, setShowDocModal] = useState(false);

  const pdfview = (documentId) => {
    const encodedDocumentId = btoa(documentId.toString());      
    const urls = DownloadDocument + encodedDocumentId;       
    try{
        sbaAxios({
            url: urls,

        }).then((response) => {
            window.open(urls);
      })
    }
    catch (error){
      console.error('Error opening PDF:', error);
    }
  }
    const fetddocdetails = async (activityId,type) => {
           try {
        const list = await sbaAxios({
            url: `${getActivityDetails}${activityId},${1}`,
            method: 'get',
        })
        list.type=type;
               setactivitydetails(list);
           }
        catch (e) {
           setactivitydetails([]);
        }
    };

    const fetchMultiDocuments = async (activityId) => {
       
    try{
        const list = await sbaAxios({ 
        url: `${getDocbyActivityId}${activityId}`,
        method: 'get',
      });
       
      setDocuments(list);
      return {docs: list, status: true}
    }
    catch(e){
      setDocuments([]);
      return {docs: [], status: false}
    }
  };

    const fetchMyActivities = async (ind) => {
    const repDate = moment().format("MM-DD-YYYY");
    try{
      const list = await sbaAxios({
        url: `${getMyActivities}/${repDate}/${ind}`
      });
        const withoutmeeting = list.filter((item) => item.ActivityType !== "Meeting").sort((a, b) => new Date(b.ActivityDate) - new Date(a.ActivityDate));
        setActivities(withoutmeeting);
    }
    catch(e){
      setActivities([]);
    }
  };

  useEffect(() => {
    fetchMyActivities(bIndex);
  },[bIndex]);

    const handleDoubleClick = async (params) => {
        if (params?.data?.ActivityType === "Document") {
            const apiResponse = await fetchMultiDocuments(params?.data?.ActivityId);
            if (apiResponse.status && apiResponse.docs?.length === 1) {
                if (apiResponse.docs[0]?.DocumentExtension?.replace(".", "").toLowerCase() === "pdf") {
                    pdfview(apiResponse.docs[0]?.DocumentId);
                }
            }
        }

        else 
        {
            setShowDocModal(true);
            const apiResponse = await fetddocdetails(params?.data?.ActivityId,params?.data?.ActivityType)
        }
  };
    const decodeHTMLEntities = (encodedString) => {
        const encodedHtmlContent = encodeURIComponent(encodedString);
        const src = `data:text/html;charset=utf-8,${encodedHtmlContent}`;
        if (encodedString == undefined)
            return "";
        return src;
    };

  const activitiesColumns = [
    { headerName: "Asset Name", field: "AssetName", tooltipField: "AssetName"},
    { headerName: "Activity Type", field: "ActivityType"},
    { 
      headerName: "Date", 
      field: "ActivityDate",
      valueFormatter: (params) => {
        if (!params.value) return "";
        return moment(params.value).format("MM/DD/YYYY");
      }, 
    },
    { headerName: "Description", field: "Description", tooltipField: "Description"}
  ];

  const ToolTip = () => {
  
    const colDef = [
      {field: 'DocumentName', headerName: "Document"}
  ]
  return <div className="ag-theme-alpine" style={{ width: '450px' ,pointerEvents:'auto' ,height:'auto'}}>
      <AgGridReact
          rowData={documents}
          columnDefs={colDef}
          defaultColDef={{ flex: 1,resizable:true }}
          onRowClicked={(params)=>{
            if(params.data?.DocumentExtension?.replace(".", "").toLowerCase() === "pdf"){
              pdfview(params.data?.DocumentId)
            }
            else{
              toast.error("Selected document is not a PDF");
            }
          }}
      ></AgGridReact>
  </div>
  };
  console.log(activitydetails,'activitydetails')

  return <>
  
  <div className="ag-theme-alpine" style={{ height: "100%", width: "100%" }}>
  <AgGridReact 
  rowData={activities}
  columnDefs={activitiesColumns}
  defaultColDef={defaulColumns}
  onRowDoubleClicked={handleDoubleClick}
  >
  </AgGridReact>
  </div>
  <Modal show={showDocModal} onHide={() => setShowDocModal(false)} size="lg" centered>
    <Modal.Header className="border p-4 m-3 mb-0 text-dark" style={{backgroundColor:"#D3EEFF"}} closeButton>
        <Modal.Title><span className="text-dark">{activitydetails?.type} Preview</span>
        <div  className="text-dark">{ activitydetails?.ActivityDocuments?.length >0 ? activitydetails?.ActivityDocuments?.map(item=>{
            
            const extension = item.DocumentExtension.replace(".", "").toLowerCase();
            const { icon, color } = fileIcons[extension] || { icon: "fa-solid fa-file", color: "#C13B1B" };
        return <>
        <div className="fs-6">{item.DocumentName} 
        <i
                className={icon + ' mx-3 SBA_hand'}
                style={{ color }}
                onClick={() => pdfview(item.DocumentId, item.DocumentExtension, item.DocumentName)}
              ></i>
        </div>
        
        </>
        }
        )    : <div className="fs-6">No Documents are Available</div> }</div>
        </Modal.Title>
    </Modal.Header>

      <Modal.Body className="pt-0">
        {activitydetails ? (
          <div className="p-4 rounded border pt-0 border-top-0">
            <div>
            </div>
            <div className="bg-white">
              {/* <div className="d-flex gap-3 py-2">
                <div>
                  <label className="" style={{ fontWeight: 600 }}>Created By :</label>
                  <label className="fw-medium mb-2">
                    {activitydetails?.ActivitySummary?.ActivityName ?? "N/A"}
                  </label>
                </div>
                <div>
                  <label className="" style={{ fontWeight: 600 }}>Created Date :</label>
                  <label className="fw-medium mb-2">
                    {moment(activitydetails?.ActivitySummary?.ActivityDate).format('MM/DD/YYYY') ?? "N/A"}
                  </label>
                </div>
              </div>
              <div className="my-2"> 
              <div>
              <label className="" style={{ fontWeight: 600 }}>From :</label>
                <label className="fw-medium mb-2">
                    {activitydetails?.ActivitySummary?.ActivityName ?? "N/A"}
                  </label>
              </div>
              <div>
              <label className="" style={{ fontWeight: 600 }}>Sent :</label>
                <label className="fw-medium mb-2">
                    {activitydetails?.ActivitySummary?.ActivityName ?? "N/A"}
                  </label>
              </div>
              <div>
              <label className="" style={{ fontWeight: 600 }}>To :</label>
                <label className="fw-medium mb-2">
                    {activitydetails?.ActivitySummary?.ActivityName ?? "N/A"}
                  </label>
              </div>
               
              </div> */}
              <div className="py-2"> 
                <label className="" style={{ fontWeight: 600 }}>Subject :</label>
                <label className="fw-medium mb-2">
                    {activitydetails?.ActivitySummary?.ActivityName ?? "N/A"}
                  </label>
              </div>
              <div className="my-2"> 
                <label className="" style={{ fontWeight: 600 }}>Body :</label>
              </div>
              <div>
                <iframe
                  width="100%"
                  height="400px"
                  src={decodeHTMLEntities(activitydetails?.ActivitySummary?.ActivityDescriptionHtml)}
                ></iframe>
              </div>
            </div>
          </div>
        ) :<></>}

      </Modal.Body>

</Modal>
  </>
};

export const MyTasks = () => {
  const [investmentTasks, setInvestmentTasks] = useState([]);

  const fetchInvestmentTasks = async () => {
    try{
      const list = await sbaAxios({
        url: getInvestmentTasks,
        method: 'post',
        data:{
          startDate:null,
          endDate:null
        }
      });
      setInvestmentTasks(list);
    }
    catch(e){
      setInvestmentTasks([]);
    }
  };
  const pdfview = (documentId) => {
    const encodedDocumentId = btoa(documentId.toString());      
    const urls = DownloadDocument + encodedDocumentId;       
    try{
        sbaAxios({
            url: urls,

        }).then((response) => {
            window.open(urls);
      })
    }
    catch (error){
      console.error('Error opening PDF:', error);
    }
  }
  useEffect(() => {
    fetchInvestmentTasks();
  },[]);

  const InvestmentTasksColumns = [
    { headerName: "Task Name", field: "TaskName" },
    { 
      headerName: "Due Date", 
      field: "DueDate",
      valueFormatter: (params) => {
        if (!params.value) return "";
        return moment(params.value).format("MM/DD/YYYY");
      },
    },
  ];
  return <>
    <div className="ag-theme-alpine" style={{ height: "100%", width: "100%" }}>
    <AgGridReact 
    rowData={investmentTasks}
    columnDefs={InvestmentTasksColumns}
    defaultColDef={defaulColumns}
    >
    </AgGridReact>
    </div>
    </>
};

export const UpcomingMeetings = () => {
    const [meetings, setMeetings] = useState([]);
    const [activitydetails, setactivitydetails] = useState([]);
    const [show, setShow] = useState(false);
    const decodeHTMLEntities = (encodedString) => {
        const encodedHtmlContent = encodeURIComponent(encodedString);
        const src = `data:text/html;charset=utf-8,${encodedHtmlContent}`;
        if (encodedString == undefined)
            return "";
        return src;
    };
    const pdfview = (documentId) => {
      const encodedDocumentId = btoa(documentId.toString());      
      const urls = DownloadDocument + encodedDocumentId;       
      try{
          sbaAxios({
              url: urls,
  
          }).then((response) => {
              window.open(urls);
        })
      }
      catch (error){
        console.error('Error opening PDF:', error);
      }
    }
  const fetchUpcomingMeetings = async () => {
    const repDate = moment().format("MM-DD-YYYY");
    try{
      const list = await sbaAxios({
        url: `${getInvestmentMeetings}/${repDate}`
      });
        const data = list.sort((a, b) => new Date(b.MeetingDate) - new Date(a.MeetingDate));
        setMeetings(data);
    }
    catch(e){
      setMeetings([]);
    }
    };

    const fetddocdetails = async (activityId) => {
        try {
            const list = await sbaAxios({
                url: `${getActivityDetails}${activityId},${1}`,
                method: 'get',
            })
            list.type="Meeting"
            setactivitydetails(list);

        }
        catch (e) {
            setactivitydetails([]);

        }
    };

  useEffect(() => {
    fetchUpcomingMeetings();
  }, []);

    const handleDoubleClick = async (params) => {
      setShow(true);
    const apiResponse = await fetddocdetails(params?.data?.ActivityId)
    };
  const meetingsColumns = [
    { 
      headerName: "Meeting Date", 
      field: "MeetingDate",
      valueFormatter: (params) => {
        if (!params.value) return "";
        return moment(params.value).format("MM/DD/YYYY");
      }, 
      flex: 0.3
  },
    { headerName: "Activity Name", field: "ActivityName",tooltipField: "ActivityName" },
    
  ];
  return <>
  <div className="ag-theme-alpine" style={{ height: "100%", width: "100%" }}>
  <AgGridReact 
  rowData={meetings}
  columnDefs={meetingsColumns}
  defaultColDef={defaulColumns}
  onRowDoubleClicked={handleDoubleClick}
  >
 </AgGridReact>
  </div>
      <Modal show={show} onHide={() => setShow(false)} size="lg" centered>
      <Modal.Header className="border p-4 m-3 mb-0 text-dark" style={{backgroundColor:"#D3EEFF"}} closeButton>
        <Modal.Title><span className="text-dark">{activitydetails?.type} Preview</span>
        <div  className="text-dark">{ activitydetails?.ActivityDocuments?.length >0 ? activitydetails?.ActivityDocuments?.map(item=>{
            
            const extension = item.DocumentExtension.replace(".", "").toLowerCase();
            const { icon, color } = fileIcons[extension] || { icon: "fa-solid fa-file", color: "#C13B1B" };
        return <>
        <div className="fs-6">{item.DocumentName} 
        <i
                className={icon + ' mx-3 SBA_hand'}
                style={{ color }}
                onClick={() => pdfview(item.DocumentId, item.DocumentExtension, item.DocumentName)}
              ></i>
        </div>
        
        </>
        }
        )    : <div className="fs-6">No Documents are Available</div> }</div>
        </Modal.Title>
    </Modal.Header>

      <Modal.Body className="pt-0">
        {activitydetails ? (
          <div className="p-4 rounded border pt-0 border-top-0">
            <div>
            </div>
            <div className="bg-white">
              {/* <div className="d-flex gap-3 py-2">
                <div>
                  <label className="" style={{ fontWeight: 600 }}>Created By :</label>
                  <label className="fw-medium mb-2">
                    {activitydetails?.ActivitySummary?.ActivityName ?? "N/A"}
                  </label>
                </div>
                <div>
                  <label className="" style={{ fontWeight: 600 }}>Created Date :</label>
                  <label className="fw-medium mb-2">
                    {moment(activitydetails?.ActivitySummary?.ActivityDate).format('MM/DD/YYYY') ?? "N/A"}
                  </label>
                </div>
              </div>
              <div className="my-2"> 
              <div>
              <label className="" style={{ fontWeight: 600 }}>From :</label>
                <label className="fw-medium mb-2">
                    {activitydetails?.ActivitySummary?.ActivityName ?? "N/A"}
                  </label>
              </div>
              <div>
              <label className="" style={{ fontWeight: 600 }}>Sent :</label>
                <label className="fw-medium mb-2">
                    {activitydetails?.ActivitySummary?.ActivityName ?? "N/A"}
                  </label>
              </div>
              <div>
              <label className="" style={{ fontWeight: 600 }}>To :</label>
                <label className="fw-medium mb-2">
                    {activitydetails?.ActivitySummary?.ActivityName ?? "N/A"}
                  </label>
              </div>
               
              </div> */}
              <div className="py-2"> 
                <label className="" style={{ fontWeight: 600 }}>Subject :</label>
                <label className="fw-medium mb-2">
                    {activitydetails?.ActivitySummary?.ActivityName ?? "N/A"}
                  </label>
              </div>
              <div className="my-2"> 
                <label className="" style={{ fontWeight: 600 }}>Body :</label>
              </div>
              <div>
                <iframe
                  width="100%"
                  height="400px"
                  src={decodeHTMLEntities(activitydetails?.ActivitySummary?.ActivityDescriptionHtml)}
                ></iframe>
              </div>
            </div>
          </div>
        ) :<></>}

      </Modal.Body>


      </Modal>
  </>
};

export const DDQStatus = () => {
  const [ddqStatus, setDDQStatus] = useState([]);
  const fetchInvestmentDDQ = async () => {
    const repDate = moment().format("MM-DD-YYYY");
    try{
      const list = await sbaAxios({
        url: `${getInvestmentDDQ}/${repDate}`
      });
      setDDQStatus(list);
    }
    catch(e){
      setDDQStatus([]);
    }
  };

  useEffect(() => {
    fetchInvestmentDDQ();
  },[]);
  const ddqColumns = [
    { headerName: "Asset Name", field: "AssetName",tooltipField: "AssetName" },
    { headerName: "Owner", field: "PrimaryAnalyst",tooltipField: "PrimaryAnalyst" },
    { headerName: "Last Reviewed", field: "LastDDQ" },
  ];

  return <>
  <div className="ag-theme-alpine" style={{ height: "100%", width: "100%" }}>
  <AgGridReact 
  rowData={ddqStatus}
  columnDefs={ddqColumns}
  defaultColDef={defaulColumns}
  >
  </AgGridReact>
  </div>
  </>
};

export const InvestedAUM = () => {
  const [investedAUM, setInvestedAUM] = useState([]);
  const fetchInvestedAssetAUM = async () => {
    const repDate = moment().format("MM-DD-YYYY");
    try{
      const list = await sbaAxios({
        url: `${getInvestedAssetAUM}/${repDate}`
      });
      setInvestedAUM(list);
    }
    catch(e){
      setInvestedAUM([]);
    }
  };

  useEffect(() => {
    fetchInvestedAssetAUM();
  },[]);
  const assetAUMColumns = [
    { headerName: "Asset Name", field: "AssetName", tooltipField: "AssetName"},
    { 
      headerName: "Date", 
      field: "AUMDate",
      valueFormatter: (params) => {
        if (!params.value) return "";
        return moment(params.value).format("MM/DD/YYYY");
      }, 
     },
    { 
      headerName: "Firm AUM", 
      field: "FirmAUM",
      valueFormatter: (params) => {
        return new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 2,
        }).format(params.value);
      }, 
      cellStyle: { textAlign: "right" }
    },
    { 
      headerName: "Asset AUM", 
      field: "AssetAUM",
      valueFormatter: (params) => {
        return new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 2,
        }).format(params.value);
      }, 
      cellStyle: { textAlign: "right" }
    }
  ];
  return <>
    <div className="ag-theme-alpine" style={{ height: "100%", width: "100%" }}>
    <AgGridReact 
    rowData={investedAUM}
    columnDefs={assetAUMColumns}
    defaultColDef={defaulColumns}
    >
    </AgGridReact>
    </div>
    </>
};

export const ManagerAlerts = () => {
  const [data, setData] = useState([]);
  const columns = [
    { headerName: "Asset Name", field: "assetName" },
    { headerName: "Alert Type", field: "alertType" },
    { headerName: "Description", field: "description" },
  ];
  return <>
    <div className="ag-theme-alpine" style={{ height: "100%", width: "100%" }}>
    <AgGridReact 
    rowData={data}
    columnDefs={columns}
    defaultColDef={defaulColumns}
    >
    </AgGridReact>
    </div>
    </>
};

export const ClientPerformance = () => {
  const [data, setData] = useState([]);
  const columns = [
    { headerName: "Client Name", field: "clientName" },
    { headerName: "MTD", field: "mtd" },
    { headerName: "YTD", field: "ytd" },
  ];
  return <>
    <div className="ag-theme-alpine" style={{ height: "100%", width: "100%" }}>
    <AgGridReact 
    rowData={data}
    columnDefs={columns}
    defaultColDef={defaulColumns}
    >
    </AgGridReact>
    </div>
    </>
};
const fileIcons = {
  pdf: { icon: "fas fa-file-pdf", color: "#F40F02" },
  xlsx: { icon: "fas fa-file-excel", color: "#1D6F42" },
  xls: { icon: "fas fa-file-excel", color: "#1D6F42" },
  png: { icon: "fas fa-file-image", color: "#1E3050" },
  jpg: { icon: "fas fa-file-image", color: "#1E3050" },
  jpeg: { icon: "fas fa-file-image", color: "#1E3050" },
  gif: { icon: "fas fa-file-image", color: "#1E3050" },
  doc: { icon: "fas fa-file-word", color: "#2284D9" },
  docx: { icon: "fas fa-file-word", color: "#2284D9" },
  ppt: { icon: "fas fa-file-powerpoint", color: "#C13B1B" },
  pptx: { icon: "fas fa-file-powerpoint", color: "#C13B1B" },
};
